<template>
  <div class="edit-video-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="860px" :before-close="handleClose"
               :close-on-click-modal="false" top="20px">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <div class="flex" style="display: flex">
          <el-form-item label="Logo" prop="logo">
            <base-upload :cover="params.logo" :action="action" @successCallback="handleAvatarSuccess" :wSize="64"
                         :hSize="64" :width="'64px'" :height="'64px'"></base-upload>
            <p class="red">图片尺寸：64 * 64</p>
          </el-form-item>
          <el-form-item label="Banner" prop="cover">
            <base-upload :cover="params.cover" :action="action" @successCallback="handleCoverSuccess" :wSize="375"
                         :hSize="154" :width="'375px'" :height="'154px'"></base-upload>
            <p class="red">图片尺寸：375 * 154</p>
          </el-form-item>
        </div>
        <el-form-item label="类型:" prop="type">
          <el-select v-model="params.type" size="small">
            <el-option v-for="item in typeList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用名称" prop="title">
          <el-input v-model="params.title" placeholder="请输入标题" size="small"></el-input>
        </el-form-item>
        <el-form-item label="应用描述" prop="desc">
          <el-input  placeholder="请输入内容" v-model="params.desc" size="small"></el-input>
        </el-form-item>
        <el-form-item label="广告有效期:" prop="timeArr">
          <el-date-picker
              v-model="timeArr"
              style="width: 100%"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              value-format="yyyy-MM-ddTHH:mm:ss+08:00"
              :default-time="['00:00:00', '23:59:59']"
              @change="handleChangeTime"
          />
          有效期： ({{ dayText }}天)
        </el-form-item>
        <el-form-item label="链接类型:" prop="href">
          <el-select v-model="hrefOptions" size="small" @change="handleChangeOptions">
            <el-option v-for="item in linkOptions" :value="item.value" :label="item.label"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转链接" prop="href">
          <el-input v-model="params.href" size="small"
                    placeholder="请填写链接，如果是外网链接请以http或者https://开头"></el-input>
        </el-form-item>
        <el-col :span="12">
          <el-form-item label="排序" prop="sorted">
            <el-input v-model.number="params.sorted" size="small" placeholder="请填写排序"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="浏览数" prop="clicknum">
            <el-input v-model.number="params.clicknum" size="small" placeholder="请填写排序"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否发布" prop="status">
            <el-select v-model.number="params.status" style="width: 100%">
              <el-option :value="1" label="上架"></el-option>
              <el-option :value="2" label="下架"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否推荐" prop="pushFlag">
            <el-select v-model.number="params.pushFlag" style="width: 100%">
              <el-option :value="1" label="推荐应用"></el-option>
              <el-option :value="2" label="取消推荐"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="布局方式" prop="position">
            <el-select v-model.number="params.position" style="width: 100%">
              <el-option :value="1" label="横排"></el-option>
              <el-option :value="2" label="宫格"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否Banner" prop="banner">
            <el-select v-model.number="params.banner" style="width: 100%">
              <el-option :value="1" label="是"></el-option>
              <el-option :value="2" label="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      timeArr: [],
      dayText: 0,
      hrefOptions: "",
      linkOptions: [
        {label: '外部链接', value: ''},
        {label: '会员中心(站内)', value: 'yinseinner://vip_page'},
        {label: '短视频(站内)', value: 'yinseinner://short_video'},
        {label: '套图(站内)', value: 'yinseinner://video_image'},
        {label: '积分福利(站内)', value: 'yinseinner://jf_fuli'},
        {label: '应用中心(站内)', value: 'yinseinner://yy_center'},
        {label: '金币充值(站内)', value: 'yinseinner://vip_coin'},
        {label: '账号凭据(站内)', value: 'yinseinner://account_code'},
        {label: '分享推广(站内)', value: 'yinseinner://share_tg'},
        {label: '帖子详情页(站内)', value: 'yinseinner://postdetail/(帖子ID: 括号内容请自行更换)'},
      ],
      typeList: [
        {label: '导航广告', value: 1},
      ],
      // 图片上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      params: {
        title: "",
        logo: "",
        cover: "",
        desc: '',
        type: 1,
        href: '',
        sorted: 1,
        status: 1,
        pushFlag: 2, // 1 推荐 2不推荐
        position: 1,
        banner: 2,
        clicknum: 0,
        startTime: "",
        endTime: "",
      },
      rules: {
        type: [{required: true, message: '请选择导航广告类型', trigger: 'blur'}],
        title: [{required: true, message: '请输入标题', trigger: 'blur'}],
      }
    }
  },
  methods: {
    formatTime(seconds) {
      if (!seconds) return '00:00';
      // 计算小时、分钟和秒
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      // 根据小时、分钟、秒的值来构建时间字符串
      let timeString = '';

      if (hours > 0) {
        timeString += `${hours.toString().padStart(2, '0')}:`;
      }

      if (minutes > 0 || hours > 0) {
        timeString += `${minutes.toString().padStart(2, '0')}:`;
      } else if (hours > 0) {
        // 如果没有分钟，直接显示秒数
        timeString += `${minutes.toString().padStart(2, '0')}:`;
      }

      timeString += secs.toString().padStart(2, '0');
      return timeString;
    },
    handleChangeOptions(option) {
      this.params.href = option
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        title: "",
        logo: "",
        cover: "",
        desc: '',
        type: 1,
        href: '',
        sorted: 1,
        status: 1,
        pushFlag: 2, // 1 推荐 2不推荐
        position: 1,
        banner: 2,
        clicknum: 0,
        startTime: "",
        endTime: "",
      }
      this.timeArr = []
      this.$refs.form.resetFields()
    },
    // 标签封面上传成功回掉
    handleCoverSuccess(res) {
      this.params.cover = res.data.coverImg;
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.logo = res.data.coverImg
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '编辑导航广告') {
            this.editAnnou()
          } else {
            this.addAnnou()
          }
        } else {
          return false;
        }
      });
    },
    editAnnou() {
      if (this.timeArr && this.timeArr.length > 0) {
        this.params.startTime = this.timeArr[0]
        this.params.endTime = this.timeArr[1]
      }
      if (this.params.href) {
        if (!(this.params.href.startsWith("http") || this.params.href.startsWith("https") ||
            this.params.href.startsWith("yinseinner"))) {
          this.$message.error('请选择一个内网地址或者填写外网链接地址不合法！');
          this.flag = false
          return;
        }
      }
      let params = Object.assign(this.params, {id: this.id});
      API.editItem(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerAnnouList')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    handleChangeTime() {
      if (this.timeArr && this.timeArr.length > 0) {
        const startDate = new Date(this.timeArr[0]);
        const endDate = new Date(this.timeArr[1]);
        const timeDifference = endDate.getTime() - startDate.getTime();
        const daysDifference = Math.abs(Math.ceil(timeDifference / (1000 * 3600 * 24)));
        this.dayText = daysDifference
        this.params.timeDays = daysDifference * 86400
        this.params.startTime = this.timeArr[0]
        this.params.endTime = this.timeArr[1]
      } else {
        this.dayText = 0
        this.params.timeDays = 0
        this.params.startTime = ""
        this.params.endTime = ""
      }
    },
    addAnnou() {
      let params = this.params;
      if (this.timeArr && this.timeArr.length > 0) {
        this.params.startTime = this.timeArr[0]
        this.params.endTime = this.timeArr[1]
      }

      if (this.params.href) {
        if (!(this.params.href.startsWith("http") || this.params.href.startsWith("https") ||
            this.params.href.startsWith("yinseinner"))) {
          this.$message.error('请选择一个地址或者填写的地址不合法！');
          this.flag = false
          return;
        }
      }

      API.saveItem(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerAnnouList')
        } else {
          this.$message.error('新增失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑导航广告'
        this.id = data.id
        this.params.title = data.title
        this.params.logo = data.logo
        this.params.cover = data.cover
        this.params.desc = data.desc
        this.params.type = data.type
        this.params.href = data.href
        this.params.sorted = data.sorted
        this.params.status = data.status
        this.params.pushFlag = data.pushFlag
        this.params.position = data.position
        this.params.banner = data.banner
        this.params.clicknum = data.clicknum
        this.params.startTime = data.startTime
        this.params.endTime = data.endTime
        if (data.startTime && data.endTime) {
          this.timeArr = [data.startTime, data.endTime]
        }
      } else {
        this.title = '新增导航广告'
        this.timeArr = []
      }
    }
  }
}
</script>

<style lang="scss">
</style>
